/**
 * Normalizes user typing in amount fields so values like "0." are not collapsed to 0
 * (which happens with Number("0.") === 0).
 *
 * @param {string} raw - value from an input (commas normalized to dots)
 * @returns {string|''|null} Keep user typing as string for controlled inputs
 */
export function normalizeDecimalAmountInput(raw) {
  if (raw == null) return '';
  const s = String(raw).replace(/,/g, '.').trim();
  if (s === '') return '';

  if (s === '.') return '0.';

  if (!/^\d*\.?\d*$/.test(s)) {
    return null;
  }

  return s;
}

/**
 * Value for controlled inputs (preserves 0 and intermediate strings).
 */
export function decimalAmountDisplayValue(v) {
  if (v === '' || v === null || v === undefined) return '';
  return String(v);
}
